import styled from "styled-components";

export default function InputContainer(props) {
  const { inputClass } = props;

  let content = <GenericContainer>{props.children}</GenericContainer>;

  if (inputClass === "multiInput") {
    content = <MultiInput>{props.children}</MultiInput>;
  }

  return content;
}

const GenericContainer = styled.div`
  margin: 1rem 0;
`;

const MultiInput = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  gap: 1rem;
`;
